import React, { useState } from 'react';
import './ContactSection.css';
import logo from '../../public/favicon.png';

const ContactSection = ({ showContact }) => {
  const [copyStatus, setCopyStatus] = useState('');

  const handleCopyPhone = () => {
    const phoneNumber = '0982631339';
    if (navigator.clipboard) {
      navigator.clipboard.writeText(phoneNumber)
        .then(() => {
          setCopyStatus('Đã sao chép!');
          setTimeout(() => setCopyStatus(''), 2000);
        })
        .catch(err => {
          console.error('Failed to copy phone number: ', err);
          setCopyStatus('Lỗi sao chép!');
          setTimeout(() => setCopyStatus(''), 2000);
        });
    } else {
      // Fallback for browsers that don't support clipboard API
      const textArea = document.createElement('textarea');
      textArea.value = phoneNumber;
      textArea.style.position = 'fixed';  //avoid scrolling to bottom
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.width = '2em';
      textArea.style.height = '2em';
      textArea.style.padding = 0;
      textArea.style.border = 'none';
      textArea.style.outline = 'none';
      textArea.style.boxShadow = 'none';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          setCopyStatus('Đã sao chép!');
        } else {
          setCopyStatus('Lỗi sao chép!');
        }
      } catch (err) {
        console.error('Fallback: Failed to copy phone number: ', err);
        setCopyStatus('Lỗi sao chép!');
      }
      document.body.removeChild(textArea);
      setTimeout(() => setCopyStatus(''), 2000);
    }
  };

  if (!showContact) {
    return null;
  }

  return (
    <section className="contact-section">
      <div className="contact-container">
        <div className="contact-logo">
          <img src={logo} alt="Luận Số Điện Thoại Logo" className="contact-logo-img" />
          <div className="contact-icons">
            <a href="mailto:binhbitec@gmail.com" target="_blank" rel="noopener noreferrer">
              <i className="fas fa-envelope"></i>
            </a>
            <a href="https://www.facebook.com/lethebinh13" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://www.youtube.com/@chihuyai" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>
        <div className="contact-info">
          <h3 className="contact-name">Lê Thế Bình</h3>
          <ul className="contact-bio">
            <li>4+ năm chiêm nghiệm và luận giải số điện thoại cho hàng trăm người</li>
            <li>Người tạo ra công cụ luận số mà bạn đang sử dụng</li>
          </ul>
          <div className="contact-phone" onClick={handleCopyPhone}>
            <i className="fas fa-phone"></i>
            <span>0982631339 (Tư vấn MIỄN PHÍ qua Zalo)</span>
            {copyStatus && <span className="copy-status">{copyStatus}</span>}
          </div>
          <div className="contact-email">
            <i className="fas fa-envelope"></i>
            <span>binhbitec@gmail.com</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
